import { combineReducers, configureStore } from '@reduxjs/toolkit';
import openRegistrationReducer from '../../pages/openRegistration/redux';
import marketplaceExpansionReducer from '../../pages/marketplaceExpansion/redux';
import termsReducer from '../../pages/terms/redux';
import sharedReducer from './redux';
import accountSettingsReducer from './account-settings-slice';
import registrationSliceReducer from './registration-slice';
import notificationReducer from './notifications-slice';
import alertReducer from './alert-slice';
import businessRegistrationNumberReducer from './business-registration-number-slice';
import { configurationApi } from '@services/configuration';
import { accountApi } from '@services/account/account';
import { registrationApi } from '@services/registration/registration';
import { addressApi } from '@services/address';
import { captchaApi } from '@services/captcha';
import { activationApi } from '@services/activation/activation';
import { combineAccountsApi } from '@services/combine-accounts/combineAccounts';

const rootReducer = combineReducers({
  openRegistration: openRegistrationReducer,
  marketplaceExpansion: marketplaceExpansionReducer,
  notification: notificationReducer,
  alert: alertReducer,
  accountSettings: accountSettingsReducer,
  registration: registrationSliceReducer,
  shared: sharedReducer,
  terms: termsReducer,
  businessRegistration: businessRegistrationNumberReducer,
  [configurationApi.reducerPath]: configurationApi.reducer,
  [accountApi.reducerPath]: accountApi.reducer,
  [registrationApi.reducerPath]: registrationApi.reducer,
  [captchaApi.reducerPath]: captchaApi.reducer,
  [addressApi.reducerPath]: addressApi.reducer,
  [activationApi.reducerPath]: activationApi.reducer,
  [combineAccountsApi.reducerPath]: combineAccountsApi.reducer,
});

export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        configurationApi.middleware,
        accountApi.middleware,
        registrationApi.middleware,
        addressApi.middleware,
        captchaApi.middleware,
        activationApi.middleware,
        combineAccountsApi.middleware,
      ),
    preloadedState,
  });
}

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
